import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'

import { selectUserData } from '../../reducers/userDataReducer'
import { getTimezoneShortName, getBuildingTimezoneFromEvent } from '../../helpers/helpers'

class MonthEvent extends React.Component {
  render() {
    const { type, start, title, canceled, clients, mainClient, buildingId } = this.props.event
    const buildingName = buildingId ? buildingId.name : ''
    const isAppointment = type ? type.personal : false
    const role = this.props.userData.user ? this.props.userData.user.role : null
    let isMain = null
    let color = type.color
    const timezone = getBuildingTimezoneFromEvent(this.props.event)
    const isCompleted = moment().tz(timezone).isAfter(moment(start).tz(timezone, true))
    if (isCompleted && (role === 'Administrator' || role === 'Manager')) {
      if (mainClient && clients && clients.length > 0) {
        isMain = clients.find((client) => client.id === mainClient.id)
      }
      color = isMain ? (isMain.participation ? '#55AA55' : '#D46A6A') : type.color
    }
    let eventClass = 'ctp-event'
    if (color === type.color && (isCompleted || canceled)) {
      eventClass += ' ctp-event--archive'
    }
    if (moment(start).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY')) {
      eventClass += ' ctp-event--today'
    }
    const time = moment(start).format('hh:mmA')
    return (
      <div className={eventClass}>
        <div className="ctp-event__inner">
          <time className="ctp-event__time" style={{ backgroundColor: color }}>
            {time.slice(0, -1)} {role !== 'Client' ? getTimezoneShortName(timezone) : null}
          </time>
          <div className="ctp-event__title">
            {isAppointment || role === 'Client' || role === 'PropertyManager'
              ? title
              : `${buildingName} - ${title}`}
          </div>
        </div>
      </div>
    )
  }
}

MonthEvent.propTypes = {
  event: PropTypes.object,
  userData: PropTypes.object,
}

export default connect((state, _props) => ({ userData: selectUserData(state) }))(MonthEvent)
